import { render, staticRenderFns } from "./warningLog.vue?vue&type=template&id=c0bceae6&"
import script from "./warningLog.vue?vue&type=script&lang=js&"
export * from "./warningLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports